import { TranslationMessages } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";

import en from "./en";
import fr from "./fr";

const translations: Record<string, TranslationMessages> = { en, fr };

export const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale],
  "en",
  [
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
  ],
  { allowMissing: true },
);
